import { useNavigate } from 'react-router-dom';
import { followLink } from '@/lib/homeLayout';

export default function DesktopGiftCard({ s, theme }) {
  const navigate = useNavigate();
  return (
    <section className="bg-white py-6 lg:py-12" style={{ fontFamily: theme.body_font }}>
      <div className="grid grid-cols-1 md:grid-cols-2 md:min-h-[380px]">
        <div className="flex flex-col justify-center px-5 md:px-10 lg:px-16 py-5 lg:py-12" style={{ background: s.bg_color }}>
          <h2 className="text-xl md:text-2xl lg:text-3xl font-bold leading-snug mb-2 lg:mb-4" style={{ fontFamily: theme.heading_font, color: s.text_color || theme.primary_color }}>{s.title}</h2>
          <p className="text-sm lg:text-base leading-relaxed mb-4 lg:mb-8 whitespace-pre-line" style={{ color: s.text_color || theme.primary_color }}>{s.text}</p>
          <div className="flex flex-row flex-wrap gap-2 lg:gap-3">
            {s.button_text && (
              <button onClick={() => followLink(s.button_link, navigate)} className="px-2 py-2 md:px-7 md:py-3 rounded-md text-white text-[10px] md:text-sm lg:text-base font-bold uppercase tracking-wide" style={{ background: theme.primary_color }}>
                {s.button_text}
              </button>
            )}
            {s.button_2_text && (
              <button onClick={() => followLink(s.button_2_link, navigate)} className="px-2 py-2 md:px-7 md:py-3 rounded-md text-[10px] md:text-sm lg:text-base font-bold uppercase tracking-wide border-2 bg-transparent" style={{ borderColor: theme.primary_color, color: theme.primary_color }}>
                {s.button_2_text}
              </button>
            )}
          </div>
        </div>
        {s.image_url ? <img src={s.image_url} alt="" loading="lazy" className="w-full h-48 md:h-full object-cover" /> : <div style={{ background: theme.primary_color }} />}
      </div>
    </section>
  );
}